const forms = {
    EN: {
        loginLabel: 'E-mail',
        email: 'E-mail',
        password: 'Password',
        noAccount: "Don't have an account?",
        signUp: 'Sign Up',
        logIn: 'Log In',
        forgotPassword: 'Forgot password?',
        resetPassword: 'Reset it now',
        accountPresent: 'Already have an account?',
        send: 'Send',
        resetPasswordSuccess: 'Email has been sent. Please follow instructions included.',
        resetConfirmSuccess: "Password has been changed. You'll be redirected to login page.",
        currentPassword: 'Current password',
        newPassword: 'New password',
        newPasswordRepeat: 'Repeat new password',
        changePasswordSuccess: 'Password has been changed.',
        add: 'Add',
        cancel: 'Cancel',
        back: 'Go back',
        cancelAdding: 'Cancel adding',
        poiName: "POI's title",
        poiRange: "POI's range",
        noPOI: 'No POI',
        address: 'Address',
        firstName: 'First name',
        lastName: 'Last name',
        roleName: 'Role name',
        phone: 'Phone',
        contactPhone: 'Contact phone number',
        voivodeship: 'Voivodeship',
        counties: 'Counties',
        noOptions: 'No options',
        city: 'City',
        postCode: 'PostCode',
        company: 'Company',
        companySupplier: 'Vehicle supplier company name',
        insurancePolicyEndDate: 'Insurance Policy End Date',
        dbsCheck: 'DBS Check',
        dbsCheck2: 'DBS Check',
        addUser: 'Add User',
        editUser: 'Edit User',
        createUserSuccess: 'User has been created',
        updateUserSuccess: 'User has been updated',
        copied: 'Copied',
        createTerminalInstallationOrderSucces: 'Terminal Installation Order has been created',
        updateTerminalInstallationOrderSucces: 'Terminal Installation Order has been updated',
        setDateTerminalInstallationOrderSucces: 'Terminal Installation Order has been planned',
        activateAccountComplete: 'Activate account',
        activateUserSuccess: 'User has been activated',
        activateUserBeginForm: 'Renew activation token',
        beginActivateUserSuccess: 'We sent information with further information at given email address',
        goBackToActivateAccountComplete: 'Back to account activate',
        goBackToLoginPage: 'Back to login page',
        creationDate: 'Creation date',
        status: 'Status',
        executionStatus: 'Execution status',
        addCarSuccess: 'Car has been added.',
        generateReport: 'Generate report',
        dateRange: 'Date Range',
        forDate: 'State for date',
        ignoreShorterThanKilometers: 'Ignore rides shorter than [km]',
        search: 'Search',
        startDate: 'Start date',
        endDate: 'End date',
        date: 'Date',
        hour: 'Hour',
        generate: 'Generate',
        writeKm: 'Write km',
        aoiName: 'Area of intrest title',
        save: 'Save',
        threePosRequired: 'You need to select atleast 3 points to create new zone',
        availableTypesOfFile: 'Available upload file types: .jpg, .jpeg, .png max: 2Mb',
        noFilesSelected: 'No file selected',
        noImagesAvailable: 'No image available for choosen vehicle.',
        carNo: 'Car number',
        driver: 'Driver',
        assignedCars: 'Assigned cars',
        fleetName: 'Fleet name',
        delete: 'Delete',
        priority: 'Priority',
        alertName: 'Alert name',
        alertCondition: 'Condition',
        conditionValue: 'Value greater than [km/h]',
        message: 'Alert message',
        alertNotifyType: 'Type of notify',
        alertSMSDiclaimer: 'Każdy wygenerowany alert z zaznaczoną opcją wysyłki SMS na zdefiniowany numer jest dodatkowo płatny. Cena jednego powiadomienia SMS to 25gr netto.',
        addCar: 'Add car',
        addFleet: 'Add fleet',
        assignedFleets: 'Assigned fleets',
        assignedDomains: 'Assigned domains',
        addZone: 'Add domain',
        sellerProposalNumber: 'Seller proposal number from sales system',
        houseNo: 'House No',
        addTerminalInstallation: 'Add terminal installation order',
        editTerminalInstallation: 'Edit terminal installation order',
        setDateTerminalInstallation: 'Set terminal installation order date',
        terminalDeliverer: 'Terminal Deliverer',
        installationDate: 'Installation date',
        technician: 'Technician',
        informationAboutTheCar: 'Information about the car',
        orderInstallationFor: 'Order installation for',
        vehicleDeliveryDetails: 'Vehicle delivery details',
        fleetOwnerEmail: 'Fleet owner\'s e-mail address',
        term: 'Term',
        assignedTechnician: 'Assigned technician',
        selectDateRequiredFirst: 'you have to select date first',
        orderStatus: 'Order status',
        contractStatus: 'Contract status',
        noOrder: 'No. order',
        noContract: 'No. contract',
        plannedEndDate: 'Planned end date',
        contractEndDate: 'End date',
        insertToSystemDate: 'Insert to system date',
        newContractNumber: 'New contract number',
        noSellerProposal: 'No. seller proposal',
        carManufacturerOrModel: 'Car manufacturer or model',
        createDate: 'Create date',
        plannedInstallationDate: 'Planned Installation',
        firstOrLastName: 'First / Last name',
        update: 'Update',
        addPOI: 'Add POI',
        accountingEmail: 'Accounting email',
        goBack: 'Back',
        name: 'Car name',
        numberOfCars: 'Number of cars',
        dateRangeSelect: 'Date range',
        mainVehicleImage: 'The main image of the vehicle',
        POI: 'POI',
        zones: 'Zones',
        generateTokenAgain: 'Generate token again',
        customerData: 'Customer data',
        addNote: 'Add note',
        turnOffReason: 'Turn off reason',
        turnOffNote: 'Turn off note',
        pickAddress: 'Pick place on a map',
        TELTONIKA_MONTAGE: 'Installation of the Teltoniki device',
        DEVICE_ID: 'Terminal number',
        DEVICE_CHANGE_VIA_NEW_PANEL: 'The GPS module can only be changed in the new system, through a dismantle or replacement order.',
        VIN_PHOTO: 'Photo of VIN number',
        CAR_FRONT_PHOTO: 'Photo of front car',
        CAR_BACK_PHOTO: 'Photo of back car',
        DASHBOARD_PHOTO: 'Photo of dashboard',
        FLEET_OWNER: 'Fleet owner'
    },
    PL: {
        loginLabel: 'E-mail',
        email: 'E-mail',
        password: 'Hasło',
        noAccount: 'Nie posiadasz jeszcze konta w serwisie?',
        signUp: 'Zarejestruj się',
        logIn: 'Zaloguj się',
        forgotPassword: 'Nie pamiętasz hasła?',
        resetPassword: 'Zresetuj je teraz',
        accountPresent: 'Posiadasz konto w serwisie?',
        send: 'Wyślij',
        resetPasswordSuccess: 'Instrukcje resetu hasła zostały wysłane na podany adres email.',
        resetConfirmSuccess: 'Hasło zostało zresetowane. Teraz zostaniesz przekierowany na stronę logowania',
        currentPassword: 'Obecne hasło',
        newPassword: 'Nowe hasło',
        newPasswordRepeat: 'Powtórz nowe hasło',
        changePasswordSuccess: 'Hasło zostało zmienione.',
        add: 'Dodaj',
        cancel: 'Anuluj',
        back: 'Cofnij',
        cancelAdding: 'Anuluj dodawanie',
        poiName: 'Nazwa POI',
        poiRange: 'Zasięg POI',
        noPOI: 'Brak POI',
        address: 'Adres',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        phone: 'Numer tel.',
        contactPhone: 'Telefon kontaktowy',
        voivodeship: 'Województwo',
        counties: 'Powiat',
        noOptions: 'Brak opcji',
        city: 'Miasto',
        postCode: 'Kod pocztowy',
        company: 'Nazwa firmy',
        companySupplier: 'Nazwa firmy dostawcy pojazdu',
        insurancePolicyEndDate: 'Data końca polisy',
        dbsCheck: 'Zaświadczenie o niekaralności',
        dbsCheck2: 'Użytkownik oświadcza, że nie był karany',
        roleName: 'Wybierz rolę użytkownika',
        addUser: 'Dodaj użytkownika',
        editUser: 'Edytuj użytkownika',
        createUserSuccess: 'Nowy użytkownik został dodany',
        updateUserSuccess: 'Użytkownik został zaktualizowany',
        copied: 'Skopiowano',
        createTerminalInstallationOrderSucces: 'Zlecenie instalacji terminalu zostało dodane',
        updateTerminalInstallationOrderSucces: 'Zlecenie instalacji terminalu zostało zaktualizowane',
        setDateTerminalInstallationOrderSucces: 'Zlecenie instalacji terminalu zostało zaplanowane',
        activateAccountComplete: 'Aktywuj konto',
        activateUserSuccess: 'Użytkownik został aktywowany',
        activateUserBeginForm: 'Odnów token aktywacji konta',
        beginActivateUserSuccess: 'Wiadomość z dalszymi wskazówkami została wysłana na podany adres email',
        goBackToActivateAccountComplete: 'Powrót do aktywacji konta',
        goBackToLoginPage: 'Przejdź do strony logowania',
        creationDate: 'Data utworzenia',
        status: 'Status',
        executionStatus: 'Tryb wykonania',
        addCarSuccess: 'Pojazd został dodany.',
        dateRange: 'Zakres dat',
        forDate: 'Stan na dzień',
        ignoreShorterThanKilometers: 'Ignoruj trasy krótsze niż',
        writeKm: 'Wpisz km',
        search: 'Szukaj',
        startDate: 'Data początkowa',
        endDate: 'Data końcowa',
        date: 'Data',
        hour: 'Godzina',
        generate: 'Generuj',
        aoiName: 'Tytuł strefy',
        save: 'Zapisz',
        threePosRequired: 'Nowa strefa musi posiadać co najmniej 3 punkty współrzędnych',
        availableTypesOfFile: 'Obsługiwane rodzaje plików: .jpg, .jpeg, .png max: 2Mb',
        noFilesSelected: 'Brak wybranego pliku',
        noImagesAvailable: 'Brak zdjęcia wybranego pojazdu',
        carNo: 'Numer pojazdu',
        driver: 'Kierowca',
        assignedCars: 'Przypisane pojazdy',
        fleetName: 'Nazwa floty',
        saveFleet: 'Zapisz flotę',
        delete: 'Usuń',
        priority: 'Priorytet',
        alertName: 'Nazwa alertu',
        alertCondition: 'Warunek',
        conditionValue: 'Wartość większa niż [km/h]',
        message: 'Wiadomość alertu',
        alertNotifyType: 'Rodzaj wiadomości',
        alertSMSDiclaimer: 'Każdy wygenerowany alert z zaznaczoną opcją wysyłki SMS na zdefiniowany numer jest dodatkowo płatny. Cena jednego powiadomienia SMS to 25gr netto.',
        addCar: 'Dodaj pojazd',
        addFleet: 'Dodaj flotę',
        assignedFleets: 'Przypisane floty',
        assignedDomains: 'Przypisane obszary',
        addZone: 'Dodaj obszar',
        saveAlert: 'Zapisz',
        choosenCar: 'Wybrany pojazd',
        generateReport: 'Generuj raport',
        dateRangePlaceholder: 'Zakres dat',
        labelNoCar: 'Brak wybranego pojazdu',
        sellerProposalNumber: 'Numer wniosku z systemu sprzedażowego',
        houseNo: 'Numer budynku',
        addTerminalInstallation: 'Dodaj zlecenie intalacji terminalu',
        editTerminalInstallation: 'Edytuj zlecenie intalacji terminalu',
        setDateTerminalInstallation: 'Ustaw datę zlecenia instalacji terminalu',
        terminalDeliverer: 'Dostawca terminalu',
        installationDate: 'Data instalacji',
        technician: 'Monter',
        informationAboutTheCar: 'Informacje o pojeździe',
        orderInstallationFor: 'Zleć montaż dla',
        vehicleDeliveryDetails: 'Dane dostawcy pojazdu',
        fleetOwnerEmail: 'Adres e-mail właściciela floty',
        term: 'Termin',
        assignedTechnician: 'Przypisany Monter',
        selectDateRequiredFirst: 'musisz najpierw wybrać datę',
        orderStatus: 'Statusy zleceń',
        contractStatus: 'Status umowy',
        noOrder: 'Nr. zlecenia',
        noContract: 'Nr. umowy',
        plannedEndDate: 'Planowana data zakończenia',
        contractEndDate: 'Data zakończenia',
        insertToSystemDate: 'Data wprowadzenia do systemu',
        newContractNumber: 'Nowy numer umowy',
        noSellerProposal: 'Nr. wniosku',
        carManufacturerOrModel: 'Marka lub model poj.',
        createDate: 'Data przyjęcia',
        plannedInstallationDate: 'Zaplanowana inst.',
        firstOrLastName: 'Imię/Nazwisko',
        update: 'Aktualizuj',
        addPOI: 'Dodaj POI',
        accountingEmail: 'Email księgowości',
        goBack: 'Powrót',
        name: 'Nazwa',
        numberOfCars: 'Liczba samochodów',
        dateRangeSelect: 'Zakres dat',
        mainVehicleImage: 'Główne zdjęcie pojazdu',
        POI: 'POI',
        zones: 'Obszary',
        generateTokenAgain: 'Wygeneruj ponownie token',
        customerData: 'Dane klienta',
        addNote: 'Dodaj notkę',
        turnOffReason: 'Powód wyłączenia',
        turnOffNote: 'Notka',
        pickAddress: 'Wskaż miejsce na mapie',
        TELTONIKA_MONTAGE: 'Montaż urządzenia Teltoniki',
        DEVICE_ID: 'Numer terminalu',
        DEVICE_CHANGE_VIA_NEW_PANEL: 'Moduł GPS można zmienić tylko w nowym systemie, przez zlecenie demontażu lub wymiany.',
        VIN_PHOTO: 'Zdjęcie numeru VIN',
        CAR_FRONT_PHOTO: 'Zdjęcie przodu auta',
        CAR_BACK_PHOTO: 'Zdjęcie tyłu auta',
        DASHBOARD_PHOTO: 'Zdjęcie kokpitu',
        GET_TRACE_AS: 'Pobierz jako trasę...',
        GET_TRACE_AS_EXCEL: 'Pobierz jako trasę Excel (.xlsx)',
        SUCCESS_SEND_REQUEST_FOR_DOWNLOAD_XLSX_TRACE: 'Pomyślnie wysłano prośbę o wygenerowanie tras(y). Plik zostanie wysłany na adres email po wygenerowaniu.',
        GET_FULL_TRACE: 'Załaduj całą trasę z wybranego przedziału',
        INFO_REQUEST_MAY_LOAD_LONGER: 'Zapytanie może trwać dłużej z powodu wyboru opcji "Załaduj całą trasę z wybranego przedziału"',
        FLEET_OWNER: 'Właściciel floty'
    }
};

export default forms;



// WEBPACK FOOTER //
// ./src/Translations/Forms.ts